// src/pages/VerifyWallet.js

import React, { useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';

const VerifyWallet = () => {
  const { login, setUserType } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const guildId = searchParams.get('guildId');
    const threadId = searchParams.get('threadId');

    console.log('VerifyWallet - guildId:', guildId);
    console.log('VerifyWallet - threadId:', threadId);

    if (guildId && threadId) {
      localStorage.setItem('guildId', guildId);
      localStorage.setItem('threadId', threadId);
      console.log('Stored guildId and threadId in localStorage.');
    } else {
      console.warn('Missing guildId or threadId in /verify-wallet route.');
      alert('Verification context is missing. Please try again.');
      // Redirect back to home
      navigate('/', { replace: true });
      return; // Prevent initiating OAuth flow
    }

    // Set userType to 'user' and initiate User OAuth Flow
    setUserType('user');
    login('user');
  }, [location, login, navigate, setUserType]);

  return <div>Redirecting to Discord for wallet verification...</div>;
};

export default VerifyWallet;

